@if (showExpand) {
    <div class="show-more-less-button" (click)="expand()">
        <span>{{ collapsedActionText }}</span>
        @if (showMoreCounter && !isEpcotEnabled) {
            <span class="more-counter"> ({{ remainingCount }}) </span>
        }
        @if (showChevron) {
            <span class="right-icon"><vn-icon name="theme-right" [size]="iconSize.toString()" /></span>
        }
    </div>
}
@if (showCollapse) {
    <div class="show-more-less-button expanded" (click)="collapse()">
        <span>{{ sitecore.event.ShowLess }}</span>
        <span class="right-icon"><vn-icon name="theme-right" [size]="iconSize.toString()" /></span>
    </div>
}
